import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';

import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

import { VIconBtn } from 'vuetify/labs/VIconBtn';

import { aliases, defaults } from './defaults';
import { icons } from './icons';
import { theme } from './theme';

const vuetifyOpts = {
  aliases,
  defaults,
  icons,
  theme,
  components: {
    ...components,
    VIconBtn
  },
  directives
};

const vuetify = createVuetify(vuetifyOpts);
export default vuetify;
